// extracted by mini-css-extract-plugin
export default {"loginWell":"_d4e6556e"};